import { FormState } from './types';

export const initialForm: FormState = {
  fotoUrl: '',
  associadoUba: false,
  codigoAssociado: '',
  nomeCompleto: '',
  dataNascimento: '',
  idade: 0,
  turma: '',
  cep: '',
  endereco: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  uf: '',
  telefoneResidencial: '',
  tamanhoCamisa: '',
  nomeMae: '',
  telefoneMae: '',
  telefoneAdicionalMae: '',
  nomePai: '',
  telefonePai: '',
  telefoneAdicionalPai: '',
  nomeRetirada: '',
  parentescoRetirada: '',
  fotoUrlRetirada: '',
  sabeNadar: false,
  autorizacaoPiscina: 'autorizado',
  possuiAlergia: false,
  alergias: '',
  possuiDoenca: false,
  doencas: '',
  tomaMedicamento: false,
  medicamentos: '',
  medicacaoHiperatividade: false,
  medicamentosHiperatividade: '',
  transporteVan: false,
  participacaoBingo: false,
  consentimentoLido: false,
  gratuito: false
};

// Esta edição não oferece adicionais. O componente e os campos permanecem
// disponíveis para reativação em futuras edições.
export const exibirAdicionais = false;

export const etapas = [
  'Dados da Criança',
  'Endereço',
  'Camisa',
  'Responsáveis',
  'Retirada',
  'Informações',
  'Adicionais',
  'Consentimento'
];

export const etapasAtivas = etapas
  .map((nome, index) => ({ nome, numero: index + 1 }))
  .filter((etapa) => exibirAdicionais || etapa.numero !== 7);

export const estados = [
  ['AC', 'Acre'],
  ['AL', 'Alagoas'],
  ['AP', 'Amapá'],
  ['AM', 'Amazonas'],
  ['BA', 'Bahia'],
  ['CE', 'Ceará'],
  ['DF', 'Distrito Federal'],
  ['ES', 'Espírito Santo'],
  ['GO', 'Goiás'],
  ['MA', 'Maranhão'],
  ['MT', 'Mato Grosso'],
  ['MS', 'Mato Grosso do Sul'],
  ['MG', 'Minas Gerais'],
  ['PA', 'Pará'],
  ['PB', 'Paraíba'],
  ['PR', 'Paraná'],
  ['PE', 'Pernambuco'],
  ['PI', 'Piauí'],
  ['RJ', 'Rio de Janeiro'],
  ['RN', 'Rio Grande do Norte'],
  ['RS', 'Rio Grande do Sul'],
  ['RO', 'Rondônia'],
  ['RR', 'Roraima'],
  ['SC', 'Santa Catarina'],
  ['SP', 'São Paulo'],
  ['SE', 'Sergipe'],
  ['TO', 'Tocantins']
];

export const tamanhosCamisa = ['04', '06', '08', '10', '12', '14', '16', 'P', 'M', 'G', 'GG'];
